import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-values-output-order',
  slug: 'output-order',
  title: 'Sync, microtask or timer?',
  type: 'predict',
  estSeconds: 30,
  contentVersion: 1,
  isGuest: true,
});
